import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Box, Button, TextField, Select, FormControl, MenuItem, Tooltip } from "@mui/material";
// import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
import DatePicker from "react-multi-date-picker";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import moment from "moment";
// import { ModeCommentRounded } from "@mui/icons-material";
import {
  Divider,
} from "@mui/material";

function a11yProps(value) {
  if (!value) {
    return {
      disabled: true,
      style: { backgroundColor: "#ececec" },
    };
  }
}

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <div>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <CalendarTodayIcon onClick={openCalendar} />
    </div>
  )
}

export default function Schedule(props) {
  const { depends_on, onState, activeStep, start_date, end_date, handleBack, handleNext, classes } = props;

  const [temporary, settemporary] = React.useState([]);

  const [checkstate, setCheckstate] = React.useState({
    selectedValue: "",
  });

  // const [feedbackState, setFeedbackState] = React.useState(false);

  const [feedbackState, setFeedbackState] = React.useState({});

  const [selectedDates, setSelectedDates] = React.useState([]);
  const [selectedDateObjects, setSelectedDateObjects] = React.useState([]);
  // const [maxDate, setMaxDate] = useState([]);

  function handleDateChange(date) {
    if (!date || (Array.isArray(date) && date.length === 0)) {
      setSelectedDates([]);
      setSelectedDateObjects([]);
      const id = "selectedDates";
      onState((prevState) => ({
        ...prevState,
        [id]: "",
      }));
      const id1 = "feedbackno";
      onState((prevState) => ({
        ...prevState,
        [id1]: "0",
      }));
      return;
    }

    const dateArray = Array.isArray(date) ? date : [date];
    setSelectedDateObjects([...dateArray]);

    const formattedDates = dateArray
      .map((d) => {
        if (d && typeof d.format === "function") {
          return d.format("DD/MM/YYYY");
        }
        if (d instanceof Date) {
          const day = String(d.getDate()).padStart(2, "0");
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const year = d.getFullYear();
          return `${day}/${month}/${year}`;
        }
        if (typeof d === "string") {
          return d;
        }
        return null;
      })
      .filter((d) => d !== null);

    const selectedDatesCount = (formattedDates.length).toString();

    setSelectedDates(formattedDates);
    const id = "selectedDates";
    onState((prevState) => ({
      ...prevState,
      [id]: formattedDates.join(","),
    }));
    const id1 = "feedbackno";
    onState((prevState) => ({
      ...prevState,
      [id1]: selectedDatesCount,
    }));
  }

  const handlecheckChange = (event) => {
    setCheckstate({ ...checkstate, [event.target.name]: event.target.checked });
  };

  // console.log(checkstate);

  const handlecheckFeedbackChange = (event) => {
    const name = "feedbackCheckboxValue";
    const id = "feedbackState";
    setFeedbackState({ ...feedbackState, [event.target.name]: event.target.checked });
    onState((prevState) => ({
      ...prevState,
      [id]: feedbackState ? "Yes" : "No",
    }));
  };
  // console.log(feedbackState);

  // const handleFeedbackcheckChange = (event) => {
  //   const name = "selectedValue";
  //   setCheckstate({ [name]: event.target.value });
  //   setFeedbackState((prevState) => !prevState);
  //   const id = "feedbackState";
  //   onState((prevState) => ({
  //     ...prevState,
  //     [id]: feedbackState ? "No" : "Yes",
  //   }));

  //   if (id === "feedbackno") {
  //     setFeedbackNumber(parseInt(value));
  //   }
  // };
  // console.log(feedbackState);

  const handlecheckBudgetChange = (event) => {
    onState((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.checked,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.checked,
    }));
  };

  const [manageState, setManageState] = React.useState('');

  const handlecheckManageLabChange = (event) => {
    const name = "manageCheckboxValue";
    const id = "manageState";
    setManageState({ ...manageState, [event.target.name]: event.target.checked });
    onState((prevState) => ({
      ...prevState,
      [id]: manageState ? "Yes" : "No",
    }));
  };

  const handleReload = () => {
    window.location.reload();
  };

  const [emailError, setEmailError] = useState('');

  const handleChange = (e) => {
    const { id, value } = e.target;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (id === 'email' && !emailRegex.test(value)) {
      setEmailError('Please enter the email in correct format');
      onState((prevState) => ({
        ...prevState,
        [id]: "",
      }));
      settemporary((prevState) => ({
        ...prevState,
        [id]: "",
      }));
    } else {
      setEmailError('');
      onState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const handleKeyPress = (event) => {
    // List of restricted special characters
    const restrictedCharacters = ['_', '-', '%', /* add more characters as needed */];

    // Check if the pressed key is in the list of restricted characters
    if (restrictedCharacters.includes(event.key)) {
      event.preventDefault();
    }
  };

  const [masterValue, setMasterValue] = useState('');
  const [masterOrRelatedValue, setMasterOrRelatedValue] = useState('');

  const handleDropdownChange = (event) => {
    const { name, value } = event.target;
    onState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name === "selectedMasterOrRelatedLab") {
      setMasterOrRelatedValue(event.target.value);
    }
    if (name === "selectedMasterLab") {
      setMasterValue(event.target.value);
    }
  };

  useEffect(() => {
    setMasterValue('');
    let name = "selectedMasterLab";
    onState((prevState) => ({
      ...prevState,
      [name]: '',
    }));
  }, [masterOrRelatedValue]);

  useEffect(() => {
    setMasterValue('');
    setMasterOrRelatedValue('');
    const name = "selectedMasterOrRelatedLab";
    onState((prevState) => ({
      ...prevState,
      [name]: "",
    }));
    settemporary((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    const name1 = "selectedMasterLab";
    onState((prevState) => ({
      ...prevState,
      [name1]: "",
    }));
    settemporary((prevState) => ({
      ...prevState,
      [name1]: "",
    }));

  }, [temporary.guacmoleLabState]);

  const handleMeetingLinkChange = (e) => {
    const { id, value } = e.target;
    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  useEffect(() => {
    setSelectedDates([]);
    setSelectedDateObjects([]);
    const id = "selectedDates";
    onState((prevState) => ({
      ...prevState,
      [id]: "",
    }));

    const id1 = "feedbackno";
    onState((prevState) => ({
      ...prevState,
      [id1]: "",
    }));

    const id2 = "feedbackState";
    onState((prevState) => ({
      ...prevState,
      [id2]: "",
    }));
  }, [feedbackState]);

  useEffect(() => {
    const id = "env_keep_date"
    onState((prevState) => ({
      ...prevState,
      [id]: "",
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: "",
    }));
  }, [temporary.env_keep]);



  const [bothChecked, setBothChecked] = React.useState(false);
  const [bothValue, setBothValue] = React.useState(false);

  useEffect(() => {
    if (checkstate.checkedB && feedbackState.feedbackCheckbox) {
      setBothChecked(true);
      if (temporary.email && selectedDates.length) {
        setBothValue(true);
      } else {
        setBothValue(false);
      }
    } else {
      setBothChecked(false);
      setBothValue(false);
    }
  }, [checkstate.checkedB, feedbackState.feedbackCheckbox, temporary.email, selectedDates]);
  // console.log(bothChecked);
  // console.log(bothValue);
  // console.log(temporary.email);
  // console.log("temporary.env_keep", temporary.env_keep);
  // console.log("temporary.env_keep_date", temporary.env_keep_date);

  const getTenDaysAfterEndDate = (endDate) => {
    if (!endDate) {
      return "";
    }
    const date = new Date(endDate);
    date.setDate(date.getDate() + 10); // Adds 10 days to the end date
  
    // Format the date to "YYYY-MM-DD"
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}`;
  };

  return (
    <React.Fragment>
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }} style={{ marginBottom: '-30px' }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Notification{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-18px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkstate.checkedB}
                onChange={handlecheckChange}
                name="checkedB"
                color="secondary"
              />
            }
            label={
              <Typography variant="h6"> Receive Labs Details Alerts </Typography>
            }
          />
        </Grid>
        <Typography variant="h8">
          Lab start/stop notifications are sent to the lab creator by default. To include additional users, provide their email addresses below.
        </Typography>
        <Grid item xs={12} sx={{ pt: 2, marginTop: '-10px' }} >
          <Grid item md={6} xs={12}>
            <Typography variant="h6"> Email Address: </Typography>
            <TextField
              fullWidth
              name="email"
              id="email"
              onChange={handleChange}
              required
              type="email"
              placeholder={localStorage.getItem("email")}
              {...a11yProps(checkstate.checkedB)}
              variant="outlined"
              InputProps={{
                style: {
                  height: "40px",
                },
              }}
              error={!!emailError}
              helperText={emailError}
            ></TextField>
          </Grid>
          <Typography variant="h5">
            <small>
              Note: Provide the email addresses in comma-separated format
            </small>
          </Typography>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Feedback{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-30px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={feedbackState.feedbackCheckbox}
                onChange={handlecheckFeedbackChange}
                name="feedbackCheckbox"
                color="secondary"
              />
            }
            label={
              <Typography variant="h6"> Check the box and select the dates if trainees are required to submit feedback. </Typography>
            }
          />
        </Grid>
        <Grid item xs={12} >
          <Grid item md={6} xs={12}>
            {/* <Typography variant="h6"> Feedback Number </Typography>
          <TextField
            fullWidth
            name="feedbackno"
            id="feedbackno"
            onChange={handleChange}
            required
            autoComplete="feedbackno"
            type="number"
            {...a11yProps(feedbackState.feedbackCheckbox)}
            variant="outlined"
            inputProps={{ min: "0", max: "25", step: "1" }}
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          ></TextField> */}
            <Box marginTop={0}>
              <Typography variant="h6"> Choose the dates for submitting feedback
                <DatePicker
                  multiple
                  id="selectedDates"
                  style={{ marginRight: "10px" }}
                  render={<CustomMultipleInput />}
                  onChange={handleDateChange}
                  {...a11yProps(feedbackState.feedbackCheckbox)}
                  value={selectedDateObjects && selectedDateObjects.length > 0 ? selectedDateObjects : []}
                  // minDate={start_date}
                  // maxDate={end_date}
                />
              </Typography>
              {selectedDates.length > 0 && (
                <Typography style={{ marginTop: "10px" }} variant="body1">
                  <Typography variant="h6" component="span">Selected Dates:</Typography>{" "}
                  {selectedDates.join(", ")}
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Manage Labs{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckManageLabChange}
                  name="manage_lab"
                  color="secondary"
                  disabled={depends_on !== "during_training"}
                />
              }
              label={<Typography variant="h6"> During Training Hours </Typography>}
            />
          </Grid>
        </Grid>
        <Typography variant="h8">
          Allow users to start/stop lab servers beyond training hours.
        </Typography>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Keep Lab Environment{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckBudgetChange}
                  name="env_keep"
                  color="secondary"
                />
              }
              label={<Typography variant="h6"> Retain the lab environment </Typography>}
            />
          </Grid>
          {temporary.env_keep ? (
            <Grid item md={3} xs={3}>
              <TextField
                fullWidth
                name="env_keep_date"
                id="env_keep_date"
                type="date"
                onChange={handleChange}
                required
                variant="outlined"
                InputProps={{
                  style: {
                    height: "40px",
                  },
                }}
                inputProps={{
                  min: end_date,
                  max: getTenDaysAfterEndDate(end_date),
                }}
              />
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        <Typography variant="h8">
          Enable and select dates to retain the lab environment if the lab is required beyond the stop date or if the lab budget exceeded.
        </Typography>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Meeting Link{" "}
          </Typography>
        </Box>
        <Typography variant="h8">
          Please share the meeting link
        </Typography>
        <Grid item md={6} xs={12}>
          <TextField
            fullWidth
            name="meetingLink"
            id="meetingLink"
            onChange={handleMeetingLinkChange}
            required
            type="text"
            variant="outlined"
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          ></TextField>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckBudgetChange}
                  name="disable_copypaste"
                  color="secondary"
                />
              }
              label={<Typography variant="h6"> Disable copy paste for instance lab </Typography>}
            />
          </Grid>
        </Grid>
      </Box>
      {/* <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckBudgetChange}
                  name="guacmoleLabState"
                  color="secondary"
                />
              }
              label={<Typography variant="h6"> Link this lab with existing lab </Typography>}
            />
          </Grid>
        </Grid>
        {temporary.guacmoleLabState && (
          <>
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Grid item xs={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="lab-select-label">Select Master Or Related Lab</InputLabel>
                  <Select
                    labelId="lab-select-label"
                    value={masterOrRelatedValue}
                    name="selectedMasterOrRelatedLab"
                    onChange={handleDropdownChange}
                    label="Select Master Or Related Lab"
                  >
                    <MenuItem value="master">Master</MenuItem>
                    <MenuItem value="related">Related</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Box>
            {masterOrRelatedValue === "master" && (
              <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="master-lab-select-label">Select the Master Lab</InputLabel>
                    <Select
                      labelId="master-lab-select-label"
                      value={masterValue}
                      name="selectedMasterLab"
                      onChange={handleDropdownChange}
                      label="Select Master Lab"
                    >
                      <MenuItem value="master 0">Master 0</MenuItem>
                      <MenuItem value="master 1">Master 1</MenuItem>
                      <MenuItem value="master 2">Master 2</MenuItem>
                      <MenuItem value="master 3">Master 3</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Box>
            )}
          </>
        )}
      </Box> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and reset this step">
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleReload}
                className={classes}
                sx={{ borderRadius: '50px' }}
              >
                Cancel
              </Button>
            </span>
          </Tooltip>
        </div>
        <div className={classes}>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step">
              <span>
                <Button onClick={handleBack} className={classes} sx={{ borderRadius: '50px', mr: 0.5 }}>
                  Back
                </Button>
              </span>
            </Tooltip>
          )}
          <Tooltip title={(
              (feedbackState.feedbackCheckbox && selectedDates.length === 0) ||
              (checkstate.checkedB && !temporary.email) ||
              (bothChecked && (!temporary.email || selectedDates.length === 0) ||
                (temporary.env_keep && !temporary.env_keep_date))
            ) ? "Complete required fields to proceed" : "Proceed to next step"}>
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes}
                disabled={
                  (feedbackState.feedbackCheckbox && selectedDates.length === 0) ||
                  (checkstate.checkedB && !temporary.email) ||
                  (bothChecked && (!temporary.email || selectedDates.length === 0) ||
                    (temporary.env_keep && !temporary.env_keep_date)) 
                  //   || (temporary.guacmoleLabState && !masterOrRelatedValue) ||
                  // (temporary.guacmoleLabState && masterOrRelatedValue === "master" && !masterValue)
                }
                sx={{ borderRadius: '50px' }}
              >
                Next
              </Button>
            </span>
          </Tooltip>
        </div>
      </Box>
    </React.Fragment>
  );
}
